import { render, staticRenderFns } from "./PastReservation.vue?vue&type=template&id=916140d2&scoped=true&"
import script from "./PastReservation.vue?vue&type=script&lang=js&"
export * from "./PastReservation.vue?vue&type=script&lang=js&"
import style0 from "./PastReservation.vue?vue&type=style&index=0&id=916140d2&prod&lang=scss&scoped=true&"
import style1 from "./PastReservation.vue?vue&type=style&index=1&id=916140d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916140d2",
  null
  
)

export default component.exports